/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

/* global gtag */

// You can delete this file if you're not using it
import "bootstrap/dist/css/bootstrap.min.css"

import "bootstrap/dist/js/bootstrap.min"
import "/src/styles/style.css"

import "@popperjs/core/dist/umd/popper.min"

import "@fontsource/lato"
import "@fontsource/lato/400-italic.css"
import "@fontsource/lato/100.css"
import "@fontsource/lato/100-italic.css"
import "@fontsource/lato/700.css"
import "@fontsource/lato/700-italic.css"
import PreserveQueryParams from "./src/components/PreserveQueryParams"
import React from "react"


const addScript = url => {
  const script = document.createElement("script")
  script.src = url
  script.async = true
  document.body.appendChild(script)
}

export const onRouteUpdate = ({location, prevLocation}) => {
  addScript("https://code.jquery.com/jquery-3.5.1.slim.min.js")
  //addScript("https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/js/bootstrap.bundle.min.js")
  addScript(
    "https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js"
  )
  addScript(
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js"
  )

  var elements = {
    header: document.querySelector(".navbar"),
  }

 
  // Add Header Shadow on Scroll ~~~~~~~~~~~~~~~~~~~~

  document.addEventListener(
    "scroll",
    function () {
      if (window.scrollY > 1) {
        elements.header.classList.add("graynav")
      } else {
        elements.header.classList.remove("graynav")
      }
    },
    false
  )

  if (typeof gtag !== 'undefined') {
    const params = new URLSearchParams(location.search)
    const msParam = params.get('ms')

    // Option A: Set globally (recommended — avoids duplicates)
    gtag("set", "campaign_source", msParam || "(not set)")

    // Optional: Debug
    console.debug("[Tracking] Applied campaign_source:", msParam || "(not set)")
  }
}





export const wrapRootElement = ({ element }) => (
  <PreserveQueryParams>{element}</PreserveQueryParams>
)
